module.exports = __webpack_public_path__ + "static/media/sante-login.9e69636f.svg";